import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Device"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDevice: build.query<GetDeviceApiResponse, GetDeviceApiArg>({
        query: () => ({ url: `/Device` }),
        providesTags: ["Device"],
      }),
      postDevice: build.mutation<PostDeviceApiResponse, PostDeviceApiArg>({
        query: (queryArg) => ({
          url: `/Device`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Device"],
      }),
      getDeviceById: build.query<GetDeviceByIdApiResponse, GetDeviceByIdApiArg>(
        {
          query: (queryArg) => ({ url: `/Device/${queryArg}` }),
          providesTags: ["Device"],
        }
      ),
      putDeviceById: build.mutation<
        PutDeviceByIdApiResponse,
        PutDeviceByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Device/${queryArg.id}`,
          method: "PUT",
          body: queryArg.deviceDto,
        }),
        invalidatesTags: ["Device"],
      }),
      deleteDeviceById: build.mutation<
        DeleteDeviceByIdApiResponse,
        DeleteDeviceByIdApiArg
      >({
        query: (queryArg) => ({ url: `/Device/${queryArg}`, method: "DELETE" }),
        invalidatesTags: ["Device"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as deviceApi };
export type GetDeviceApiResponse = /** status 200 OK */ DeviceDto[];
export type GetDeviceApiArg = void;
export type PostDeviceApiResponse = /** status 201 Created */ number;
export type PostDeviceApiArg = DeviceDto;
export type GetDeviceByIdApiResponse = /** status 200 OK */ DeviceDto;
export type GetDeviceByIdApiArg = number;
export type PutDeviceByIdApiResponse = /** status 200 OK */ void;
export type PutDeviceByIdApiArg = {
  id: number;
  deviceDto: DeviceDto;
};
export type DeleteDeviceByIdApiResponse = unknown;
export type DeleteDeviceByIdApiArg = number;
export type DeviceDto = {
  id: number;
  serialNumber: string;
  productionYear: number;
  firmware: string;
  macAddress?: string | null;
  comment?: string | null;
  commissioningDate?: string | null;
  maintenanceCycle?: string | null;
  timeSynchronisationType?: string | null;
  model: number;
  ipAddress?: string | null;
  subnetMask?: string | null;
  isUsed: boolean;
  wasEverUsed: boolean;
  hostName?: string | null;
  defaultGateway?: string | null;
  connectionPort?: string | null;
  available?: boolean;
  availabilityLastUpdated?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetDeviceQuery,
  useLazyGetDeviceQuery,
  usePostDeviceMutation,
  useGetDeviceByIdQuery,
  useLazyGetDeviceByIdQuery,
  usePutDeviceByIdMutation,
  useDeleteDeviceByIdMutation,
} = injectedRtkApi;
